// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetSiHaDocumentationSafetyHookListRequestModel from '../../model/get-si-ha-documentation-safety-hook-list-request-model';
import GetSiHaDocumentationSafetyHookListRequestDTO from '../dto/get-si-ha-documentation-safety-hook-list-request-dto';
import dtoSchema from '../schemas/get-si-ha-documentation-safety-hook-list-request-schema';

export default abstract class GetSiHaDocumentationSafetyHookListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetSiHaDocumentationSafetyHookListRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetSiHaDocumentationSafetyHookListRequestDTO>): GetSiHaDocumentationSafetyHookListRequestModel;
  static toModel(dto: DeepPartial<GetSiHaDocumentationSafetyHookListRequestDTO> | undefined | null): GetSiHaDocumentationSafetyHookListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetSiHaDocumentationSafetyHookListRequestDTO> | undefined | null): GetSiHaDocumentationSafetyHookListRequestModel | undefined {
    return dto ? new GetSiHaDocumentationSafetyHookListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetSiHaDocumentationSafetyHookListRequestModel> | GetSiHaDocumentationSafetyHookListRequestModel): GetSiHaDocumentationSafetyHookListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetSiHaDocumentationSafetyHookListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetSiHaDocumentationSafetyHookListRequestModel, can not map to GetSiHaDocumentationSafetyHookListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
